module.exports = __webpack_public_path__ + "components/rewards/sport-pursuit/static/logo-bb1e50a45cff0d478c34aa782486b69e.jpg";